"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Null = _interopRequireDefault(require("../primitive/Null"));

// Copyright 2017-2019 @polkadot/types authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * @name Origin
 * @description
 * Where Origin occurs, it should be ignored as an internal-only value, so it should
 * never actually be constructed
 */
class Origin extends _Null.default {
  constructor() {
    super();
    throw new Error('Origin should not be constructed, it is only a placeholder for compatibility');
  }

}

exports.default = Origin;